import React from "react";
import { Button } from "@chakra-ui/react";
import { deleteContent } from "../../../services/SolutionDetailAPI";
import { useSetRecoilState } from "recoil";
import { IS_MODIFY_MODE, SOLUTION_CONTENT_ID, CURRENT_CONTENT, CONTENT_TYPE } from "../../../recoilState/Atoms";

const ContentCard = (props) => {
    const setModifyMode = useSetRecoilState(IS_MODIFY_MODE);
    const setContentId = useSetRecoilState(SOLUTION_CONTENT_ID);
    const setCurrentContent = useSetRecoilState(CURRENT_CONTENT);
    const setContentType = useSetRecoilState(CONTENT_TYPE);

    const confirmDelete = () => {
        if (window.confirm("해당 컨텐츠를 정말로 삭제하시겠습니까??")) {
            deleteContent(props.id).then(() => {
                alert("삭제가 완료되었습니다.");
                props.setUpdateState(Math.random());
            });
        }
    };

    return (
        <>
            {props.type === "text" ? (
                <div style={{ marginTop: "1%", fontSize: "large", border: "1px dotted gray" }}>
                    {props.content}{" "}
                    <>
                        <Button fontSize="xl" size="md" colorScheme="red" mr={3} onClick={() => confirmDelete()}>
                            텍스트 삭제
                        </Button>
                        <Button
                            fontSize="xl"
                            size="md"
                            colorScheme="blue"
                            mr={3}
                            onClick={() => {
                                setModifyMode(true);
                                props.setIsContentAddModalOpen(true);
                                setContentId(props.id);
                                setCurrentContent(props.content);
                                setContentType("text");
                            }}
                        >
                            텍스트 수정
                        </Button>
                    </>
                </div>
            ) : (
                <div className="justify-center items-center my-10">
                    <div className="h-full flex">
                        <img
                            src={props.content}
                            className="rounded-lg w-[100%]"
                            alt="Subject Image"
                            style={{ border: "1px dotted gray" }}
                        />{" "}
                    </div>
                    <Button fontSize="xl" size="md" colorScheme="red" mr={3} onClick={() => confirmDelete()}>
                        이미지 삭제
                    </Button>
                    <Button
                        fontSize="xl"
                        size="md"
                        colorScheme="blue"
                        mr={3}
                        onClick={() => {
                            setModifyMode(true);
                            props.setIsContentAddModalOpen(true);
                            setContentId(props.id);
                            setCurrentContent(props.content);
                            setContentType("image");
                        }}
                    >
                        이미지 수정
                    </Button>
                </div>
            )}
        </>
    );
};
export default ContentCard;
